(() => {
  const source = document.getElementById('SyPickupData');
  if (!source) return;
  let data;
  try { data = JSON.parse(source.textContent); } catch (_) { return; }
  const labels = data.labels || {};
  const locations = Array.isArray(data.locations) ? data.locations : [];
  const API = '/api/2026-10/graphql.json';
  const ATTR = 'Pickup kitchen';
  const byName = name => locations.find(l => l.name === name);
  const state = { kitchen: byName(data.selected || '') || null, pending: Promise.resolve(true), revision: 0 };

  const request = (url, options = {}) => fetch(url, { ...options, credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
  const cartToken = async () => (await request('/cart.js').then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })).token;
  async function setPreference(location) {
    const token = await cartToken();
    if (!token) return false;
    const delivery = location && !location.hold
      ? { deliveryMethod: ['PICK_UP'], pickupHandle: [String(location.id)] }
      : { deliveryMethod: [], pickupHandle: [] };
    const res = await request(API, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: 'mutation($id:ID!,$bi:CartBuyerIdentityInput!){cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:$bi){userErrors{message}}}',
        variables: { id: 'gid://shopify/Cart/' + token, bi: { preferences: { delivery } } }
      })
    }).then(r => { if (!r.ok) throw new Error('Preference unavailable'); return r.json(); });
    return !res.errors?.length && !!res?.data?.cartBuyerIdentityUpdate && !(res.data.cartBuyerIdentityUpdate.userErrors || []).length;
  }
  async function setAttribute(location) {
    const res = await request('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR]: location ? location.name : '' } })
    });
    return res.ok;
  }
  function saveKitchen(location) {
    const chosen = location && !location.hold ? location : null;
    state.kitchen = chosen;
    state.revision += 1;
    state.pending = state.pending.catch(() => false).then(async () => {
      try {
        if (!await setPreference(chosen)) return false;
        return await setAttribute(chosen);
      } catch (_) { return false; }
    });
    return state.pending;
  }
  function announceFailure() {
    document.querySelectorAll('sy-pickup-details [data-sy-status]').forEach(el => { el.textContent = labels.saveFailed || ''; });
  }
  function checkoutUrl(location) {
    const b = location.billing || {};
    const q = Object.keys(b).filter(k => b[k]).map(k => `checkout[billing_address][${k}]=` + encodeURIComponent(b[k]));
    return '/checkout' + (q.length ? '?' + q.join('&') : '');
  }

  let checkingOut = false;
  async function openCheckout() {
    if (checkingOut) return;
    checkingOut = true;
    try {
      const revision = state.revision;
      const chosen = state.kitchen;
      const ok = await saveKitchen(chosen);
      if (!ok) { announceFailure(); return; }
      if (state.revision !== revision + 1) return;
      window.location.assign(chosen ? checkoutUrl(chosen) : '/checkout');
    } finally { checkingOut = false; }
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;
    const button = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!button || (!state.kitchen && state.revision === 0) || button.disabled) return;
    event.preventDefault();
    openCheckout();
  });
  document.addEventListener('submit', event => {
    if (event.defaultPrevented || (!state.kitchen && state.revision === 0)) return;
    const button = event.submitter;
    if (!button || button.name !== 'checkout' || button.disabled) return;
    event.preventDefault();
    openCheckout();
  });

  class PickupDetails extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('select');
      if (this.select) {
        const option = (label, value) => {
          const element = document.createElement('option');
          element.textContent = label;
          element.value = value;
          return element;
        };
        this.select.replaceChildren(option(labels.placeholder, ''));
        locations.forEach(location => this.select.add(option(location.name, location.id)));
        if (state.kitchen) this.select.value = state.kitchen.id;
        this.select.addEventListener('change', () => this.choose(this.select.value));
        this.querySelector('[data-sy-clear]')?.addEventListener('click', () => this.choose(''));
        document.addEventListener('sy:kitchen', e => { if (e.detail.from !== this) this.sync(e.detail.id); });
      }
      this.querySelector('[data-sy-copy]')?.addEventListener('click', () => this.copy());
      this.showLocation(this.select ? (state.kitchen?.id || '') : (this.dataset.locationId || ''));
    }

    sync(id) {
      if (this.select) this.select.value = id;
      this.showLocation(id);
    }

    async choose(id) {
      const location = locations.find(item => item.id === String(id)) || null;
      if (this.select) this.select.value = location ? location.id : '';
      document.dispatchEvent(new CustomEvent('sy:kitchen', { detail: { id: location ? location.id : '', from: this } }));
      this.showLocation(location ? location.id : '');
      const status = this.querySelector('[data-sy-status]');
      const pending = saveKitchen(location);
      const revision = state.revision;
      const ok = await pending;
      if (!status || state.revision !== revision) return;
      if (!ok) status.textContent = labels.saveFailed || '';
      else if (!location) status.textContent = labels.cleared || '';
    }

    showLocation(id) {
      const location = locations.find(item => item.id === String(id));
      const result = this.querySelector('[data-sy-result]');
      const actions = this.querySelector('[data-sy-actions]');
      const map = this.querySelector('[data-sy-map]');
      const call = this.querySelector('[data-sy-call]');
      const clear = this.querySelector('[data-sy-clear]');
      const text = this.querySelector('[data-sy-copy-text]');
      const notice = this.querySelector('[data-sy-notice]');
      const address = this.querySelector('[data-sy-address]');
      this.location = location;
      if (result) result.hidden = !location;
      if (actions) actions.hidden = true;
      if (clear) clear.hidden = !location;
      if (map) map.removeAttribute('href');
      if (call) { call.hidden = true; call.removeAttribute('href'); }
      if (text) { text.value = ''; text.hidden = true; }
      this.querySelector('[data-sy-status]').textContent = '';
      if (!location) return;
      if (address) address.textContent = location.hold ? '' : location.address;
      if (notice) {
        const prefill = this.select && !location.hold && labels.prefill;
        notice.textContent = location.hold ? labels.held : (prefill ? labels.prefill : labels.choose);
        notice.classList.toggle('sy-pickup__note--prefill', !!prefill);
      }
      if (call && /^\+?[0-9 ]{7,18}$/.test(location.phone || '')) {
        call.href = 'tel:' + location.phone.replace(/ /g, '');
        call.hidden = false;
      }
      if (location.hold) return;
      if (actions) actions.hidden = false;
      if (map) map.href = /^https:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(location.map || '')
        ? location.map
        : 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('Sushiya, ' + location.address);
      if (text) text.value = [labels.pickup + ': Sushiya — ' + location.name, location.address,
        labels.phone + ': ' + (location.phone || ''), labels.order, labels.ready].join('\n');
    }

    async copy() {
      if (!this.location || this.location.hold) return;
      const selectedId = this.location.id;
      const text = this.querySelector('[data-sy-copy-text]');
      const status = this.querySelector('[data-sy-status]');
      try {
        await navigator.clipboard.writeText(text.value);
        if (this.location?.id === selectedId) status.textContent = labels.copied;
      } catch (_) {
        if (this.location?.id !== selectedId) return;
        text.hidden = false;
        text.focus();
        text.select();
        status.textContent = labels.copyFailed;
      }
    }
  }
  if (!customElements.get('sy-pickup-details')) customElements.define('sy-pickup-details', PickupDetails);
})();
